<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item label="老师姓名">
        <Input
          style="width:200px"
          search
          placeholder="请输入老师姓名"
          @on-search="search(1)"
          v-model="searchCondition.teacher_name"
          @keydown.native.prevent.enter="search(1)"
          clearable
        />
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        method="get"
        :columns="columns"
        data-url="/api/oto/dispatch/index"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        keyField="teacher_id"
        :selectedItems="selectedItems"
        keepSelected
      >
        <template slot="footer-left">
          <Button
            icon="ios-refresh"
            class="btn-margin-right"
            type="text"
            @click="search(1)"
            style="margin-left:5px;"
          >刷新</Button>
        </template>
        <template slot-scope="{ row }" slot="c1">
          <div class="vmiddle">
            <img class="table-avatar" :src="row.avatar" />
            <span>{{row.teacher_name}}</span>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TeacherOtoSelect',
  data() {
    return {
      columns: [
        {
          title: '姓名',
          key: 'teacher_name',
          slot: 'c1'
        }
      ],
      selectList: [],
      searchCondition: {
        teacher_name: ''
      }
    }
  },
  props: {
    selectedItems: {
      type: Array
    },
    selectType: {
      type: String,
      default: 'multi'
    }
  },
  methods: {
    rowsFormatter() {},
    search(flag) {
      if (flag == 0) {
        this.searchCondition.teacher_name = ''
      }
      this.$refs.grid.searchRefresh()
    },
    onSelectionChange(val) {
      this.selectList = [...val]
    },
    getSelectList() {
      return this.selectList
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems)
    }
  }
}
</script>
<style lang="scss">
.avatar {
  max-width: 64px;
}
</style>